export const topologyConfig = {
  startTopologyX: 2,
  startTopologyY: 2,

  nodeWidth: 280 + 52,
  nodeHeight: 52,
  nodePadding: 12,
  nodeLinesGap: 4,
  nodeGap: 12,

  nodeStrokeWidth: 2,

  zoneDefaultWidth: 1000,
  zoneMarginTop: 100,
  zoneNodeMarginBottom: 100,
  zoneMarginTopWireless: 150,
  zoneTopBracketHeight: 80,
  zoneTitleToLineGap: 18,

  // Inside Zone
  rightChildrenGapX: 200,
  nodeGapY: 12,
  bottomChildrenGapY: 60,

  // Add buttons
  addBtnWidth: 130,
  addBtnHeight: 36,
  addBtnMarginTop: 20,
  addBtnMarginLeft: 25,
};
